module.exports = __webpack_public_path__ + "img/depmap_svg_V120.d1b77f95.svg";